<template>
  <div class="google-map-search">
    <google-map
      :inputBox="1"
      :latitude="modalGoogleMapComponentPropData.lat"
      :longitude="modalGoogleMapComponentPropData.lng"
    >
    </google-map>
  </div>
</template>

<script>
import GoogleMap from './GoogleMap'
import { mapGetters } from 'vuex'
export default {
  name: 'google-map-search',
  components: { GoogleMap },
  computed: {
    ...mapGetters(['modalGoogleMapComponentPropData'])
  }
}
</script>

<style lang="scss" scoped>
.google-map-search {
  width: 100%;
  height: 100%;
  .google-map {
    width: 100%;
    height: 100%;
  }
}
</style>
